var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex mt-2"},[_c('div',{staticClass:"side-frame-warning"}),_c('div',[_c('span',{staticStyle:{"font-size":"14px","color":"#606266"}},[_vm._v(" "+_vm._s(_vm.$l('table_title_order_detail') || '产品明细列表')+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }